import { XIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { SELECT_CHIP_REMOVE_BTN } from '~/components/Select/shared/testIDs';
import { type DefaultChipType } from '~/components/Select/shared/types';

type SelectChipRemoveButtonProps<T extends DefaultChipType> = {
  chip: T;
  onClick: (chip: T) => void;
};

export const SelectChipRemoveButton = <T extends DefaultChipType>({
  chip,
  onClick,
}: SelectChipRemoveButtonProps<T>) => {
  return (
    <IconButton
      adsIcon
      appearance="ghost"
      color="gray"
      className="ml-0.5"
      // biome-ignore lint/plugin: PLA-1724 — pre-existing debt, not introduced by the icon migration
      data-testid={`${SELECT_CHIP_REMOVE_BTN}-${chip.label}`}
      icon={XIcon}
      label="Remove chip"
      // biome-ignore lint/performance/noJsxPropsBind: PLA-1724 — pre-existing debt, not introduced by the icon migration
      onClick={(event) => {
        event.stopPropagation();
        onClick(chip);
      }}
      size="extra-small"
    />
  );
};
